@if (inputType != 'checkbox') {
  <div class="py-2" id="password">
    <label class="{{ lableClass }}">{{ labelText }}</label>
    @if (inputType == 'password') {
      <div class="input-group {{ inputWrapperClass }}">
        <input
          #input
          type="{{ passwordFieldType }}"
          id="{{ inputId ? inputName : inputName }}"
          name="{{ inputName }}"
          class="{{ inputClass }}"
          [ngClass]="{ 'border-danger': touched && error }"
          [value]="fcontrol?.value"
          (keyup)="onChange($event, input.value)"
          (input)="onChange($event, input.value)"
          (paste)="onPaste($event)"
          placeholder="{{ inputPlaceHolder ? inputPlaceHolder : labelText }}"
        />
        <a
          href="javascript:void(0)"
          (click)="passwordShowHide()"
          class="{{ iconWrapperClass }}"
          role="button"
        >
          <i class="{{ passwordEyeIcon }}"></i>
        </a>
        @if (touched && error && error.required) {
          <span class="error-message">
            {{ errorMessage_required ? errorMessage_required : errorMessage }}
          </span>
        }
        @if (touched && error && error.pattern) {
          <span class="error-message">
            {{ errorMessage_pattern }}
          </span>
        }
      </div>
    }
    @if (inputType == 'text' || inputType == 'email' || inputType == 'number') {
      <div class="input-group {{ inputWrapperClass }}">
        <input
          #input
          type="{{ inputType }}"
          id="{{ inputId ? inputName : inputName }}"
          name="{{ inputName }}"
          class="{{ inputClass }}"
          [ngClass]="{ 'border-danger': touched && error }"
          (keyup)="onChange($event, input.value)"
          (input)="onChange($event, input.value)"
          (paste)="onPaste($event)"
          [value]="fcontrol?.value"
          placeholder="{{ inputPlaceHolder ? inputPlaceHolder : labelText }}"
        />
        @if (icon) {
          <a
            href="javascript:void(0)"
            class="{{ iconWrapperClass }}"
            role="button"
          >
            <i class="{{ icon }}"></i>
          </a>
        }
        @if (touched && error && error.required) {
          <span class="error-message">
            {{ errorMessage_required ? errorMessage_required : errorMessage }}
          </span>
        }
        @if (touched && error && error.pattern) {
          <span class="error-message">
            {{ errorMessage_pattern }}
          </span>
        }
      </div>
    }
  </div>
}
@if (inputType == 'checkbox') {
  <div class="py-2" id="password">
    @if (inputType == 'checkbox') {
      <div
        class="form-check form-switch d-flex gap-2 align-items-center ms-auto"
      >
        <label class="text-muted fs-6">{{ labelText }}</label>
        <input
          #input
          type="{{ inputType }}"
          (change)="onChangecheckbox($event, input.value)"
          class="form-check-input input-switch m-0 ms-auto"
          value="{{ currentValue }}"
          [checked]="checkbox"
          [value]="fcontrol?.value"
        />
      </div>
    }
  </div>
}
